import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import { Document, Page } from 'react-pdf'

function AbstractPdfViewer({ file }: { file: string }) {
  const modalRef = useRef<HTMLDivElement | null>(null)

  const [numPages, setNumPages] = useState<number>()
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [pageWidth, setPageWidth] = useState<number>(0)

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages)
  }

  useEffect(() => {
    function updateWidth() {
      if (modalRef.current) {
        setPageWidth(modalRef.current.offsetWidth)
      }
    }

    if (open) {
      // Defer the width calculation to the next render cycle
      requestAnimationFrame(updateWidth)
      window.addEventListener('resize', updateWidth)
    }

    return () => {
      window.removeEventListener('resize', updateWidth)
    }
  }, [])

  return (
    <div ref={modalRef}>
      <div className="min-h-36 flex items-center justify-center">
        <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
          <Page
            width={pageWidth}
            renderAnnotationLayer={false}
            renderTextLayer={false}
            pageNumber={pageNumber}
          />
        </Document>
      </div>
      <div
        style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0.5rem 0',
        }}
      >
        <button
          style={{
            backgroundColor: '#E85B33', // Replace with your gcf-blue-4 equivalent
            color: 'white',
            padding: '0.25rem 0.75rem',
            borderRadius: '9999px',
            border: 'none',
            cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer',
            opacity: pageNumber <= 1 ? 0.6 : 1,
          }}
          onClick={() => {
            setPageNumber((prev) => Math.max(prev - 1, 1))
          }}
          disabled={pageNumber <= 1}
        >
          Prev
        </button>
        <span>
          Page {pageNumber} of {numPages}
        </span>
        <button
          style={{
            backgroundColor: '#E85B33', // Replace with your gcf-blue-4 equivalent
            color: 'white',
            padding: '0.25rem 0.75rem',
            borderRadius: '9999px',
            border: 'none',
            cursor: pageNumber >= (numPages || 1) ? 'not-allowed' : 'pointer',
            opacity: pageNumber >= (numPages || 1) ? 0.6 : 1,
          }}
          onClick={() => {
            setPageNumber((prev) => Math.min(prev + 1, numPages || 1))
          }}
          disabled={pageNumber >= (numPages || 1)}
        >
          Next
        </button>
      </div>
    </div>
  )
}

export default AbstractPdfViewer
